// removed by extract-text-webpack-plugin
module.exports = {"link":"_5StuW","text":"_2FhLh","tags":"_1ICNH","tag":"_2Spe2","tagsLabel":"_1xfrN"};